import { useQuery } from "@tanstack/react-query";
import { docParsing } from "@/api/docParsing.service";
import type { OriginalSubmissionLoad } from "../../utils/originalSubmissionState";

function errorStatus(error: unknown): number | null {
  const status = (error as { status?: unknown } | null)?.status;
  return typeof status === "number" ? status : null;
}

function errorCode(error: unknown): string | null {
  const code = (error as { code?: unknown } | null)?.code;
  return typeof code === "string" ? code : null;
}

/** Loads the original submission's parsed result, only while the panel is open. */
export function useOriginalSubmission(input: {
  docParseResultId: string | null;
  open: boolean;
}): OriginalSubmissionLoad {
  const { docParseResultId, open } = input;
  const query = useQuery({
    queryKey: ["research-source-data", docParseResultId],
    queryFn: () => docParsing.getFullResult(docParseResultId as string),
    enabled: open && docParseResultId != null,
  });

  if (query.isError)
    return {
      kind: "error",
      status: errorStatus(query.error),
      code: errorCode(query.error),
    };
  if (query.data) return { kind: "loaded", result: query.data.result };
  if (query.isLoading) return { kind: "loading" };
  return { kind: "idle" };
}
